import * as THREE from 'three';
import { ChoomaAlly } from './ChoomaAlly.js';

export class ChoomaManager {
    constructor(scene, player) {
        this.scene = scene;
        this.player = player;
        this.choomas = [];
        this.spawnTimer = 0;
        this.spawnInterval = 10; // Spawn a friendly Chooma every 10 seconds
        this.maxChoomas = 5;
        
        // Spawn initial Choomas (all of them)
        for (let i = 0; i < this.maxChoomas; i++) {
            this.spawnChooma();
        }
    }
    
    spawnChooma() {
        if (this.choomas.length >= this.maxChoomas) return;
        
        // Spawn near player but not too close
        const angle = Math.random() * Math.PI * 2;
        const radius = 10 + Math.random() * 5;
        const position = new THREE.Vector3(
            this.player.mesh.position.x + Math.cos(angle) * radius,
            1,
            this.player.mesh.position.z + Math.sin(angle) * radius
        );
        
        const chooma = new ChoomaAlly(this.scene, position);
        this.choomas.push(chooma);
        
        // Show spawn notification
        this.showSpawnNotification(position);
        
        console.log('🍄 Friendly Chooma spawned to help you!');
    }
    
    showSpawnNotification(position) {
        // Create temporary text indicator
        const canvas = document.createElement('canvas');
        canvas.width = 256;
        canvas.height = 128;
        const context = canvas.getContext('2d');
        context.fillStyle = '#ffff00';
        context.font = 'bold 48px Courier';
        context.textAlign = 'center';
        context.fillText('ALLY!', 128, 64);
        
        const texture = new THREE.CanvasTexture(canvas);
        const spriteMaterial = new THREE.SpriteMaterial({ 
            map: texture,
            transparent: true,
            opacity: 1
        });
        const sprite = new THREE.Sprite(spriteMaterial);
        sprite.position.copy(position);
        sprite.position.y += 3;
        sprite.scale.set(2, 1, 1);
        
        this.scene.add(sprite);
        
        // Animate and remove
        let opacity = 1;
        const fadeInterval = setInterval(() => {
            opacity -= 0.05;
            sprite.material.opacity = opacity;
            sprite.position.y += 0.05;
            
            if (opacity <= 0) {
                this.scene.remove(sprite);
                clearInterval(fadeInterval);
            }
        }, 50);
    }
    
    removeChooma(index) {
        if (this.choomas[index]) {
            this.choomas[index].destroy();
            this.choomas.splice(index, 1);
        }
    }
    
    respawnChoomas() {
        // Respawn all dead Choomas after boss defeat
        console.log(' Respawning Choomas after boss defeat!');
        this.choomas.forEach(chooma => {
            if (chooma.isDead) {
                chooma.health = chooma.maxHealth;
                chooma.isDead = false;
                chooma.updateHealthBar();
                console.log(' Chooma revived!');
            }
        });
    }
    
    update(deltaTime, enemies) {
        // Don't spawn new Choomas automatically - they only respawn after boss defeats
        
        // Update all Choomas
        this.choomas.forEach((chooma, index) => {
            chooma.update(deltaTime, enemies, this.choomas);
            
            // Don't remove dead Choomas - they can be revived
        });
    }
}
